import { Box, Button, Typography } from '@mui/material'
import { Modal } from 'components/Modal/Modal'
import { DataTable } from 'components/Shared/DataTable'
import { GridToolbar, useGridApiRef } from '@mui/x-data-grid'
import { ModalFullHeader } from 'components/Modal/ModalFullHeader'

const formatMetricExportValue = (value: string | number | null | undefined) => {
  if (typeof value === 'string') {
    return value
  }

  if (typeof value !== 'number') {
    return '-'
  }

  return `$${value.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`
}

export const PerformanceTrendsExport = ({
  isModalOpen,
  toggleModal,
  setMessage,
  data,
  columns,
}: {
  isModalOpen: boolean
  toggleModal: () => void
  setMessage: (message: string | null) => void
  data: any
  columns: any
}) => {
  const dataTableApiRef = useGridApiRef()

  const exportColumns = columns.map((column: any) => {
    if (column.field === 'name' || column.field === 'type') {
      return column
    }

    return {
      ...column,
      valueFormatter: ({ value }: { value: string | number | null }) =>
        formatMetricExportValue(value),
    }
  })

  const exportReportData = () => {
    dataTableApiRef.current.exportDataAsCsv({
      fileName: `PerformanceTrends`,
      utf8WithBom: true,
    })
    toggleModal()
    setMessage('Records have been downloaded.')
  }

  return (
    <Modal
      isOpen={isModalOpen}
      toggleIsOpen={toggleModal}
      sx={{
        height: { xs: '100%', sm: '50%' },
        width: { xs: '100%', sm: '40%' },
        overflow: 'hidden',
      }}
    >
      <ModalFullHeader
        toggleIsOpen={toggleModal}
        title={`Export Performance Trends`}
      />
      <>
        <Box paddingX={{ xs: 2, sm: 4 }} paddingY={{ xs: 3, sm: 1 }}>
          <Typography variant="body-2" color="text.secondary">
            CSV file format will be exported
          </Typography>
        </Box>
        <Box
          className="fixed bottom-0 border-t-[1px] w-full flex justify-end gap-2
   px-8 py-6 sm:p-4"
        >
          <Button variant="text" onClick={toggleModal}>
            Cancel
          </Button>
          <Button variant="contained" type="button" onClick={exportReportData}>
            Export
          </Button>
        </Box>
        <Box sx={{ visibility: 'hidden', width: 800, height: 600 }}>
          <DataTable
            sortFieldName="createdOn"
            apiRef={dataTableApiRef}
            columns={exportColumns}
            rows={data ?? []}
            slots={{ toolbar: GridToolbar }}
            forceDesktopTableInMobile
          />
        </Box>
      </>
    </Modal>
  )
}
